import { Component, Vue } from 'vue-property-decorator';
import appStore from '@/store/app';
import { SystemStatus, SystemStatusTimetable, SystemStatusType } from '@/types';
import CardComponent from '@/components/CardComponent';
import Notification from '@/components/Notification';

@Component({
    components: { CardComponent, Notification },
  })
export default class SystemAvailability extends Vue {

    private SystemStatus: typeof SystemStatusType = SystemStatusType;

    get loading(): boolean {
        return appStore.isLoading;
    }

    get systemStatus(): SystemStatus {
        return appStore.systemStatus;
    }

    get timetable(): SystemStatusTimetable[] {
        return appStore.systemStatus.timetable || [];
    }

    private async created() {
        await appStore.fetchSystemTimetableAsync();
    }
}